(function hotjarConversionTracking(window, document) {
  'use strict';

  var VERSION = '2026-09-02.1';
  var existing = window.SeibertronHotjar;
  if (existing && existing.version === VERSION) return;

  window.hj = window.hj || function () {
    (window.hj.q = window.hj.q || []).push(arguments);
  };

  var allowedEventName = /^[A-Za-z0-9_.:/| -]+$/;
  var recentSignals = new WeakMap();
  var openVirtualPages = new Map();
  var scanScheduled = false;

  function validEventName(name) {
    return typeof name === 'string' && name.length > 0 && name.length <= 250 && allowedEventName.test(name);
  }

  function validVirtualPath(path) {
    return typeof path === 'string' && /^\/virtual\/[A-Za-z0-9_./-]+$/.test(path);
  }

  function trackEvent(name) {
    if (!validEventName(name)) return false;
    window.hj('event', name);
    return true;
  }

  function trackVirtualPage(path, eventName) {
    if (!validVirtualPath(path)) return false;
    window.hj('stateChange', path);
    if (eventName) trackEvent(eventName);
    return true;
  }

  function signalOnce(element, name, cooldown) {
    if (!element || !validEventName(name)) return false;
    var now = Date.now();
    var previous = recentSignals.get(element);
    if (previous && previous.name === name && now - previous.at < (cooldown || 800)) return false;
    recentSignals.set(element, { name: name, at: now });
    return trackEvent(name);
  }

  function isDisabled(element) {
    return Boolean(
      element &&
      (element.disabled || element.getAttribute('aria-disabled') === 'true')
    );
  }

  function explicitClickEvent(target) {
    var element = target.closest('[data-hj-event]');
    if (!element || isDisabled(element)) return null;
    return { element: element, name: element.getAttribute('data-hj-event') };
  }

  function inferredClickEvent(target) {
    var element = target.closest('button, a, input[type="submit"], input[type="button"], [role="button"]');
    if (!element || isDisabled(element)) return null;

    if (element.matches('[name="add"], .product-form__submit, [data-add-to-cart]')) {
      return { element: element, name: 'add_to_cart_clicked' };
    }
    if (element.matches('[name="checkout"], .cart__checkout-button, [data-checkout]')) {
      return { element: element, name: 'checkout_clicked' };
    }
    if (element.closest('#cart-notification') && element.matches('a[href*="/cart"]')) {
      return { element: element, name: 'cart_view_clicked' };
    }
    if (element.closest('details-modal.header__search, .search-modal') && element.matches('button[type="submit"], input[type="submit"]')) {
      return { element: element, name: 'search_submitted' };
    }
    return null;
  }

  function formType(form) {
    var input = form && form.querySelector('input[name="form_type"]');
    return input ? input.value : '';
  }

  function inferredSubmitEvent(form) {
    if (!form) return null;
    var type = formType(form);
    var action = form.getAttribute('action') || '';

    if (type === 'create_customer') return 'account_registration_submitted';
    if (type === 'customer_login') return 'account_login_submitted';
    if (type === 'customer' && form.querySelector('input[name="contact[tags]"][value*="newsletter"]')) {
      return 'newsletter_signup_submitted';
    }
    if (/\/cart\/add(?:\.js)?(?:[?#]|$)/.test(action)) return 'add_to_cart_clicked';
    if (/\/search(?:[?#]|$)/.test(action)) return 'search_submitted';
    return null;
  }

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var match = explicitClickEvent(event.target) || inferredClickEvent(event.target);
    if (match) signalOnce(match.element, match.name, 800);
  }, true);

  document.addEventListener('submit', function (event) {
    if (!(event.target instanceof HTMLFormElement)) return;
    var name = inferredSubmitEvent(event.target);
    if (name) signalOnce(event.submitter || event.target, name, 800);
  }, true);

  function isVisible(element) {
    if (!element || !element.isConnected || element.hidden || element.getAttribute('aria-hidden') === 'true') return false;
    if (element.matches('details-modal')) {
      var disclosure = element.querySelector('details');
      if (disclosure ? !disclosure.hasAttribute('open') : !element.hasAttribute('open')) return false;
    }
    if (element.matches('details') && !element.hasAttribute('open')) return false;
    var style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
  }

  function modalDefinition(element) {
    var explicitPath = element.getAttribute('data-hj-virtual-page');
    var explicitEvent = element.getAttribute('data-hj-open-event');
    if (validVirtualPath(explicitPath)) {
      return { path: explicitPath, event: validEventName(explicitEvent) ? explicitEvent : null };
    }

    if (element.id === 'cart-notification' || element.closest('cart-notification')) {
      return { path: '/virtual/cart/item-added', event: 'product_added_to_cart' };
    }
    if (element.matches('cart-drawer, #CartDrawer, .cart-drawer')) {
      return { path: '/virtual/cart/drawer', event: 'cart_drawer_opened' };
    }
    if (element.matches('quick-add-modal, .quick-add-modal, [id^="QuickAdd-"]')) {
      return { path: '/virtual/product/quick-add', event: 'quick_add_modal_opened' };
    }
    if (element.matches('details-modal.header__search') || element.querySelector('.search-modal')) {
      return { path: '/virtual/search/modal', event: 'search_modal_opened' };
    }
    return null;
  }

  function modalCandidates() {
    return document.querySelectorAll([
      '[data-hj-virtual-page]',
      '#cart-notification',
      'cart-drawer',
      '#CartDrawer',
      '.cart-drawer',
      'quick-add-modal',
      '.quick-add-modal',
      '[id^="QuickAdd-"]',
      'details-modal.header__search'
    ].join(','));
  }

  function scanVirtualPages() {
    scanScheduled = false;
    var seen = new Set();
    modalCandidates().forEach(function (element) {
      var definition = modalDefinition(element);
      if (!definition) return;
      seen.add(element);
      var visible = isVisible(element);
      var wasVisible = openVirtualPages.has(element);

      if (visible && !wasVisible) {
        openVirtualPages.set(element, definition.path);
        trackVirtualPage(definition.path, definition.event);
      } else if (!visible && wasVisible) {
        openVirtualPages.delete(element);
      }
    });

    openVirtualPages.forEach(function (_, element) {
      if (!seen.has(element) || !element.isConnected) openVirtualPages.delete(element);
    });
  }

  function scheduleModalScan() {
    if (scanScheduled) return;
    scanScheduled = true;
    window.requestAnimationFrame(scanVirtualPages);
  }

  var modalSelector = '[data-hj-virtual-page], #cart-notification, cart-drawer, #CartDrawer, .cart-drawer, quick-add-modal, .quick-add-modal, [id^="QuickAdd-"], details-modal.header__search';
  function mutationTouchesModal(mutation) {
    if (mutation.target instanceof Element && (mutation.target.matches(modalSelector) || mutation.target.closest(modalSelector))) {
      return true;
    }
    return Array.prototype.some.call(mutation.addedNodes, function (node) {
      return node instanceof Element && (node.matches(modalSelector) || node.querySelector(modalSelector));
    });
  }

  var observer = new MutationObserver(function (mutations) {
    if (mutations.some(mutationTouchesModal)) scheduleModalScan();
  });

  function startObserver() {
    observer.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class', 'open', 'hidden', 'aria-hidden', 'style']
    });
    scheduleModalScan();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver, { once: true });
  } else {
    startObserver();
  }

  document.addEventListener('hotjar:virtual-page', function (event) {
    var detail = event.detail || {};
    trackVirtualPage(detail.path, detail.event);
  });

  window.SeibertronHotjar = {
    version: VERSION,
    trackEvent: trackEvent,
    trackVirtualPage: trackVirtualPage
  };
})(window, document);
